import * as React from 'react';
import { UniqueIdentifier } from '@dnd-kit/core';

interface UnattachedEventReportsSelectionProviderProps {
  children: React.ReactNode;
}

type UnattachedEventReportsSelectionData = {
  checkedContainer: UniqueIdentifier | null;
  handleCheckedContainerChange: (containerId: UniqueIdentifier | null) => void;
};

const UnattachedEventReportsSelectionContext = React.createContext<UnattachedEventReportsSelectionData>(undefined!);

export function UnattachedEventReportsSelectionProvider({ children }: UnattachedEventReportsSelectionProviderProps) {
  const [checkedContainer, setCheckedContainer] = React.useState<UniqueIdentifier | null>(null);

  const unattachedEventReportsSelectionData = React.useMemo<UnattachedEventReportsSelectionData>(() => ({
    checkedContainer,
    handleCheckedContainerChange: (containerId: UniqueIdentifier | null) => {
      setCheckedContainer(containerId);
    },
  }), [checkedContainer]);

  return (
    <UnattachedEventReportsSelectionContext.Provider value={unattachedEventReportsSelectionData}>
      {children}
    </UnattachedEventReportsSelectionContext.Provider>
  );
}

export const useUnattachedEventReportsSelectionData = () => React.useContext(UnattachedEventReportsSelectionContext);
